module.exports = __webpack_public_path__ + "img/armschmuck_btn.8a94816f.jpg";